// extracted by mini-css-extract-plugin
export default {"qrCodeWrapper":"styles_qrCodeWrapper__m6wii","notificationText":"styles_notificationText__NJNW5","buttonWrapper":"styles_buttonWrapper__LKDJy"};